module.exports = __webpack_public_path__ + "assets/img/9.ab1c2489.png";